import React from "react";
import azState from "../../../../assets/az_state.png";
import bar from "../../../../assets/bar_chart.png";

export const charts = [
  {
    id: "title_map",
    icon: azState,
    name: "Industry: Title Map",
    desc: "Explanation about what this means and what the narrative measures on the base level.",
    title: "Industry: Title Map",
    subtitle: "",
    floating_title: true,
    metrics: [],
  },
  {
    id: "shortage_impacts_to_industry",
    icon: bar,
    name: "Shortage Impacts to Industry",
    desc: "Explanation about what this means and what the narrative measures on the base level.",
    title: "Shortage Impacts to Industry (acre-feet)",
    subtitle: "",
    floating_title: false,
    metrics: [],
  },
];

export const about = [
  {
    title: "Summary",
    desc: (
      <p>
        This map shows the location of all mining and power entities that
        receive Colorado River water delivered through the Central Arizona
        Project (CAP) canal. The stats indicate the percent of Colorado River
        water used by priority for all Central Arizona mining entities combined
        and all Central Arizona power entities combined in 2020 (the most recent
        year for which complete data is available). For a primer on Colorado
        River water priorities in Central Arizona,{" "}
        <a href="https://experience.arcgis.com/experience/d74d9265134c44c1ba385796d95769d4/">
          click here
        </a>
        .
      </p>
    ),
  },
  {
    title: "Summary",
    desc: (
      <p>
        With this graph, a user can see the quantity of water available to the
        mining and power industries at each shortage tier and under more severe
        scenarios. The stats indicate the percent of Colorado River water used
        by priority for all Central Arizona mining entities combined and all
        Central Arizona power entities combined in 2020 (the most recent year
        for which complete data is available). For a primer on Colorado River
        water priorities in Central Arizona,{" "}
        <a href="https://experience.arcgis.com/experience/d74d9265134c44c1ba385796d95769d4/">
          click here
        </a>
        .
      </p>
    ),
  },
];

export const industry = [
  { label: "Arizona Public Service", value: 1 },
  { label: "Salt River Project", value: 2 },
  { label: "New Harquahala Generating Station", value: 3 },
  { label: "Freeport--McMoran", value: 4 },
  { label: "ASARCO", value: 5 },
  { label: "Resolution Copper", value: 6 },
  { label: "Rosemont Copper Company", value: 7 },
];
